import { createSelector } from 'reselect';

import {
  TUTORIAL_QUESTION_IN_QUESTION_LIST,
  TUTORIAL_TUTOR_PROFILE_IN_QUESTION_LIST,
  stages,
} from '@coconut/constants/tutorialSteps';

export const types = {
  SKIP_TUTORIAL: 'SKIP_TUTORIAL',
  SKIP_TUTORIAL_QUESTION_IN_QUESTION_LIST:
    'SKIP_TUTORIAL_QUESTION_IN_QUESTION_LIST',
  SKIP_TUTORIAL_TUTOR_PROFILE_IN_QUESTION_LIST:
    'SKIP_TUTORIAL_TUTOR_PROFILE_IN_QUESTION_LIST',
};

export const actions = {
  skipTutorial: () => ({
    type: types.SKIP_TUTORIAL,
  }),
  skipTutorialQuestionInList: () => ({
    type: types.SKIP_TUTORIAL_QUESTION_IN_QUESTION_LIST,
  }),
  skipTutorialTutorProfileInList: () => ({
    type: types.SKIP_TUTORIAL_TUTOR_PROFILE_IN_QUESTION_LIST,
  }),
};

export const initialState = {
  QUESTION_LIST: [
    {
      hasRead: false,
      key: TUTORIAL_QUESTION_IN_QUESTION_LIST,
    },
    {
      hasRead: false,
      key: TUTORIAL_TUTOR_PROFILE_IN_QUESTION_LIST,
    },
  ],
};

const setHasSeen = (step) => ({
  ...step,
  hasRead: true,
});

const setHasSeenOnStep = (steps, stepKey) =>
  steps.map((step) => (step.key === stepKey ? setHasSeen(step) : step)); // eslint-disable-line no-confusing-arrow

const reducer = (state = initialState, action) => {
  const questionListSteps = state[stages.QUESTION_LIST];

  switch (action.type) {
    case types.SKIP_TUTORIAL:
      return {
        ...state,
        [stages.QUESTION_LIST]: questionListSteps.map(setHasSeen),
      };
    case types.SKIP_TUTORIAL_QUESTION_IN_QUESTION_LIST:
      return {
        ...state,
        [stages.QUESTION_LIST]: setHasSeenOnStep(
          questionListSteps,
          TUTORIAL_QUESTION_IN_QUESTION_LIST
        ),
      };
    case types.SKIP_TUTORIAL_TUTOR_PROFILE_IN_QUESTION_LIST:
      return {
        ...state,
        [stages.QUESTION_LIST]: setHasSeenOnStep(
          questionListSteps,
          TUTORIAL_TUTOR_PROFILE_IN_QUESTION_LIST
        ),
      };
    default:
      return state;
  }
};

export default reducer;
const getToken = (state) => state.auth.token;
export const getCurrentStage = () => stages.QUESTION_LIST;
export const getTutorialSteps = (state) => state.questionListTutorial;
export const getCurrentTutorialStep = createSelector(
  getCurrentStage,
  getTutorialSteps,
  (currentStage, tutorialSteps) => {
    const step = tutorialSteps[currentStage].find((t) => !t.hasRead);
    if (step) return step.key;

    return '';
  }
);
export const getStateOfTutorialQuestionInList = createSelector(
  getToken,
  getCurrentTutorialStep,
  (token, CurrentTutorialStep) =>
    CurrentTutorialStep === TUTORIAL_QUESTION_IN_QUESTION_LIST && !token
);
export const getStateOfTutorialTutorProfileInList = createSelector(
  getToken,
  getCurrentTutorialStep,
  (token, CurrentTutorialStep) =>
    CurrentTutorialStep === TUTORIAL_TUTOR_PROFILE_IN_QUESTION_LIST && !token
);



// WEBPACK FOOTER //
// ./src/services/redux/questionListTutorial.js